export { default } from './BannerWithTrackingWidget';
